<template>
	<form action="/users" method="get" @submit.prevent="save">
		<div class="title-container">
			<div class="title">Update Profile</div>
		</div>

		<form-errors :errors="errors"></form-errors>

		<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
		<div class="input-container">
			<div class="input-title">Full Name</div>
			<div class="input-box"><input type="text" v-model="form.name"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
		<div class="input-container">
			<div class="input-title">Email Address</div>
			<div class="input-box"><input type="text" v-model="form.email"></div>
		</div>
		<div v-if="form.email != original.email" class="alert alert-neutral">
			<ul>
				<li><span class="fa fa-flag"></span>You will need to verify {{ form.email }} before your email is actually changed.</li>
			</ul>
		</div>
		<div v-if="original.pending_email_change" class="alert alert-neutral">
			<ul>
				<li><span class="fa fa-flag"></span>There is an email change pending for {{ original.pending_email_change }}. Please check your inbox.</li>
			</ul>
		</div>
		<submit-button text="Save Changes" error-text="Failed: See Problems Above" icon="fa-save" :loading="formSaving"></submit-button>
	</form>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators';
import FormMixin from '@/mixins/FormMixin';

export default {

	props: [ 'profile' ],

	mixins: [ FormMixin ],

	data() {
		return {
			original: Object.assign({}, this.profile || {}),
			form: Object.assign({}, this.profile || {}),
		};
	},

	validations: {
		form: {
			name: { required },
			email: { required, email },
		}
	},

	watch: {
		profile: function(newValue) {
			this.original = Object.assign(this.original, newValue || {});
		}
	},

	methods: {

		async save() {
			this.submit(async () => {
				const { data } = await this.$api.post('/user', this.form);

				this.$store.dispatch('addToast', 'Profile Updated');
				this.$store.dispatch('setUser', data);
				this.original = Object.assign({}, data);
				this.form = Object.assign({}, data);
			});
		},

	},

};

</script>
